<template>
	<div class="exam rel flex column a-center">
		<el-image fit="contain" class="logot abs" :src="require('@/assets/pc/login/logo.png')" alt="" style="" />
		<div class="montserMedium tit-38 pl-20 pr-20" style="text-align: center;">
			<!-- GoodWe Plus+ Membership Exam System -->
			{{gudingziduan.Exam.exambiaoti}}
		</div>
		<div class="tit-16 ys-66 pl-20 pr-20" style="text-align: center;">
			<!-- Pass the exam to become a GoodWe Plus+ member and unlock more exclusive membership benefits! -->
			{{gudingziduan.Exam.exambiaoti1}}
		</div>
		<div class="readys mt-110 mb-70 flex column a-center j-end" >
			<div class="annius ys-0 tit-20 inline-block cur_pointer" @click="dakaiks">
				<!-- Start Exam -->
				{{gudingziduan.Exam.exambiaoti3}}
			</div>
		</div>
		<div class="tit-18 cur_pointer" style="text-decoration: underline;color: #626262;" @click="$dakai('video')">
			<!-- Not Ready? Study more -->
			{{gudingziduan.Exam.exambiaoti4}}
		</div>
		<div v-if="!userLanguage">
			<el-dialog title="Select country and language" top="20vh" class="languages montserRegular"
				:visible.sync="initial">
				<el-tabs v-model="languageName">
					<el-tab-pane v-for="(l, i) in language" :label="l.continent" :name="i.toString()">
			
						<div class="neirong">
							
							<div class="guojia flex a-center cur_pointer" v-for="(ll,ii) in l.countries" @click="xuan(ll.country)">
								
								<el-image class="mr-7 guojia_tu" fit="contain" :src="ll.countryIcon" style="width: .4rem; height: .2rem"></el-image>
								{{ll.country}}
							</div>
							<!-- <div class="guojia flex a-center cur_pointer" @click="xuan">
								<i>
									<svg t="1733308117334" class="icon" viewBox="0 0 1568 1024" version="1.1"
										xmlns="http://www.w3.org/2000/svg" p-id="5072" width="16" height="16">
										<path
											d="M141.824 0h1268.64c80.704 0 144.288 63.392 144.288 138.976v746.016c0 78.016-63.584 138.976-141.824 138.976H141.824C63.584 1023.968 0 960.576 0 884.992V138.976C0 63.392 63.584 0 141.824 0z"
											fill="#FFFFFF" p-id="5073"></path>
										<path
											d="M1554.752 1023.936h-371.68V0h371.68v1023.936zM0 0h371.68v1023.936H0V0z m772.256 160.896L716 268.16c-7.328 12.192-17.12 9.76-29.344 4.864l-41.568-21.952L676.864 414.4c7.328 29.248-14.688 29.248-24.448 17.056l-70.912-80.448-14.688 39.008c-2.432 4.864-7.328 9.76-17.12 9.76l-90.464-19.488 24.448 85.344c4.896 19.488 9.792 26.816-4.896 31.68l-31.776 14.624L603.52 638.72c7.328 4.864 9.792 12.192 7.328 21.952l-14.688 46.336c53.792-7.328 102.688-14.624 156.512-21.952 4.896 0 12.224 7.328 12.224 12.192l-7.328 163.328h26.912l-4.896-163.328c0-4.864 7.328-14.624 12.224-12.192 53.792 4.864 102.688 14.624 156.512 21.952l-14.688-43.872a19.68 19.68 0 0 1 7.328-21.952L1097.472 514.4l-31.776-14.624c-14.688-4.864-9.792-12.192-4.896-31.68l24.448-85.344-92.928 17.056c-9.792 2.432-14.688-4.864-17.12-9.76l-12.224-41.44-68.48 80.448c-9.792 12.192-31.776 12.192-24.448-17.056l31.776-163.328-41.568 21.952c-12.224 7.328-22.016 7.328-29.344-4.864l-58.688-104.832z"
											fill="#D52B1E" p-id="5074"></path>
									</svg>
								</i>
								Canada
							</div> -->
							<!-- <div class="guojia flex a-center cur_pointer">
								<i>
									<svg t="1733308174423" class="icon" viewBox="0 0 1588 1024" version="1.1"
										xmlns="http://www.w3.org/2000/svg" p-id="9963" width="16" height="16">
										<path d="M0 0h1588.476v1024H0" fill="#FFFFFF" p-id="9964"></path>
										<path
											d="M0 80.558h1588.476V0H0m0 157.146h1588.476v80.558H0m0 76.587h1588.476v80.559H0m0 76.587h1588.476v80.559H0m0 77.154h1588.476v79.991H0m0 77.155h1588.476v80.558H0M0 1024h1588.476v-80.558H0"
											fill="#E50012" p-id="9965"></path>
										<path d="M0 551.996h688.15V0H0" fill="#1E2380" p-id="9966"></path>
										<path
											d="M56.731 66.376l17.02 13.048-6.24-20.99L84.53 45.951H62.972l-6.24-20.423-6.808 20.423H28.366l17.586 12.481-6.807 20.99L56.73 66.377z m114.598 0l17.586 13.048-6.808-20.99 17.587-12.482h-21.558L171.33 25.53l-6.24 20.423H143.53l17.02 12.481-6.24 20.99 17.019-13.047z m115.164 0l17.587 13.048-6.808-20.99 17.587-12.482H293.3l-6.808-20.423-6.808 20.423h-21.558l17.587 12.481-6.808 20.99 17.587-13.047z m115.165 0l17.019 13.048-6.24-20.99 17.019-12.482h-21.558l-6.24-20.423-6.808 20.423h-21.558l17.587 12.481-6.808 20.99 17.587-13.047z m114.597 0l17.587 13.048-6.808-20.99 17.586-12.482h-21.557l-6.808-20.423-6.808 20.423h-20.99l17.019 12.481-6.24 20.99 17.019-13.047z m115.164 0l17.587 13.048-6.808-20.99 17.02-12.482h-20.99l-6.809-20.423-6.807 20.423h-21.558l17.586 12.481-6.807 20.99 17.586-13.047z m-517.39 55.596l17.588 12.481-6.808-20.423 17.587-12.481h-21.558l-6.808-20.423-6.808 20.423H85.664l17.587 12.48-6.808 20.424 17.587-12.48z m115.165 0l17.02 12.481-6.24-20.423 17.019-12.481h-20.99l-6.809-20.423-6.807 20.423h-21.558l17.587 12.48-6.808 20.424 17.586-12.48z m114.598 0l17.586 12.481-6.807-20.423 17.586-12.481H350.6l-6.807-20.423-6.24 20.423h-21.559l17.02 12.48-6.24 20.424 17.019-12.48z m115.164 0l17.587 12.481-6.808-20.423 17.587-12.481h-21.558l-6.808-20.423-6.808 20.423h-21.557l17.586 12.48-6.807 20.424 17.586-12.48z m115.165 0l17.02 12.481-6.809-20.423 17.587-12.481h-21.558l-6.24-20.423-6.808 20.423h-21.558l17.587 12.48-6.808 20.424 17.587-12.48zM56.73 177.57l17.02 12.48-6.24-20.422 17.019-12.481H62.972l-6.24-20.424-6.808 20.424H28.366l17.586 12.48-6.807 20.424 17.586-12.481z m114.598 0l17.586 12.48-6.808-20.422 17.587-12.481h-21.558l-6.807-20.424-6.24 20.424H143.53l17.02 12.48-6.24 20.424 17.019-12.481z m115.164 0l17.587 12.48-6.808-20.422 17.587-12.481H293.3l-6.808-20.424-6.808 20.424h-21.558l17.587 12.48-6.808 20.424 17.587-12.481z m115.165 0l17.019 12.48-6.24-20.422 17.019-12.481h-21.558l-6.24-20.424-6.808 20.424h-21.558l17.587 12.48-6.808 20.424 17.587-12.481z m114.597 0l17.587 12.48-6.808-20.422 17.586-12.481h-21.557l-6.808-20.424-6.808 20.424h-20.99l17.019 12.48-6.24 20.424 17.019-12.481z m115.164 0l17.587 12.48-6.808-20.422 17.02-12.481h-20.99l-6.809-20.424-6.807 20.424h-21.558l17.586 12.48-6.807 20.424 17.586-12.481z m-517.39 55.597l17.588 12.48-6.808-20.423 17.587-12.48h-21.558l-6.808-20.424-6.808 20.423H85.664l17.587 12.481-6.808 20.424 17.587-12.481z m115.165 0l17.02 12.48-6.24-20.423 17.019-12.48h-20.99l-6.809-20.424-6.807 20.423h-21.558l17.587 12.481-6.808 20.424 17.586-12.481z m114.598 0l17.586 12.48-6.807-20.423 17.586-12.48H350.6l-6.807-20.424-6.24 20.423h-21.559l17.02 12.481-6.24 20.424 17.019-12.481z m115.164 0l17.587 12.48-6.808-20.423 17.587-12.48h-21.558l-6.808-20.424-6.808 20.423h-21.557l17.586 12.481-6.807 20.424 17.586-12.481z m115.165 0l17.02 12.48-6.809-20.423 17.587-12.48h-21.558l-6.24-20.424-6.808 20.423h-21.558l17.587 12.481-6.808 20.424 17.587-12.481zM56.73 288.762l17.02 12.481-6.24-20.423 17.019-12.48H62.972l-6.24-20.424-6.808 20.423H28.366l17.586 12.48-6.807 20.424 17.586-12.48z m114.598 0l17.586 12.481-6.808-20.423 17.587-12.48h-21.558l-6.807-20.424-6.24 20.423H143.53l17.02 12.48-6.24 20.424 17.019-12.48z m115.164 0l17.587 12.481-6.808-20.423 17.587-12.48H293.3l-6.808-20.424-6.808 20.423h-21.558l17.587 12.48-6.808 20.424 17.587-12.48z m115.165 0l17.019 12.481-6.24-20.423 17.019-12.48h-21.558l-6.24-20.424-6.808 20.423h-21.558l17.587 12.48-6.808 20.424 17.587-12.48z m114.597 0l17.587 12.481-6.808-20.423 17.586-12.48h-21.557l-6.808-20.424-6.808 20.423h-20.99l17.019 12.48-6.24 20.424 17.019-12.48z m115.164 0l17.587 12.481-6.808-20.423 17.02-12.48h-20.99l-6.809-20.424-6.807 20.423h-21.558l17.586 12.48-6.807 20.424 17.586-12.48zM114.03 344.36l17.588 12.48-6.808-20.422 17.587-12.481h-21.558l-6.808-20.424-6.808 20.424H85.664l17.587 12.48-6.808 20.424 17.587-12.481z m115.165 0l17.02 12.48-6.24-20.422 17.019-12.481h-20.99l-6.809-20.424-6.807 20.424h-21.558l17.587 12.48-6.808 20.424 17.586-12.481z m114.598 0l17.586 12.48-6.807-20.422 17.586-12.481H350.6l-6.807-20.424-6.24 20.424h-21.559l17.02 12.48-6.24 20.424 17.019-12.481z m115.164 0l17.587 12.48-6.808-20.422 17.587-12.481h-21.558l-6.808-20.424-6.808 20.424h-21.557l17.586 12.48-6.807 20.424 17.586-12.481z m115.165 0l17.02 12.48-6.809-20.422 17.587-12.481h-21.558l-6.24-20.424-6.808 20.424h-21.558l17.587 12.48-6.808 20.424 17.587-12.481zM56.73 399.956l17.02 12.48-6.24-20.423 17.019-13.048H62.972l-6.24-19.856-6.808 19.856H28.366l17.586 13.048-6.807 20.424 17.586-12.481z m114.598 0l17.586 12.48-6.808-20.423 17.587-13.048h-21.558l-6.807-19.856-6.24 19.856H143.53l17.02 13.048-6.24 20.424 17.019-12.481z m115.164 0l17.587 12.48-6.808-20.423 17.587-13.048H293.3l-6.808-19.856-6.808 19.856h-21.558l17.587 13.048-6.808 20.424 17.587-12.481z m115.165 0l17.019 12.48-6.24-20.423 17.019-13.048h-21.558l-6.24-19.856-6.808 19.856h-21.558l17.587 13.048-6.808 20.424 17.587-12.481z m114.597 0l17.587 12.48-6.808-20.423 17.586-13.048h-21.557l-6.808-19.856-6.808 19.856h-20.99l17.019 13.048-6.24 20.424 17.019-12.481z m115.164 0l17.587 12.48-6.808-20.423 17.02-13.048h-20.99l-6.809-19.856-6.807 19.856h-21.558l17.586 13.048-6.807 20.424 17.586-12.481z m-517.39 55.596l17.588 12.481-6.808-20.423 17.587-13.048h-21.558l-6.808-20.423-6.808 20.423H85.664l17.587 13.048-6.808 20.423 17.587-12.48z m115.165 0l17.02 12.481-6.24-20.423 17.019-13.048h-20.99l-6.809-20.423-6.807 20.423h-21.558l17.587 13.048-6.808 20.423 17.586-12.48z m114.598 0l17.586 12.481-6.807-20.423 17.586-13.048H350.6l-6.807-20.423-6.24 20.423h-21.559l17.02 13.048-6.24 20.423 17.019-12.48z m115.164 0l17.587 12.481-6.808-20.423 17.587-13.048h-21.558l-6.808-20.423-6.808 20.423h-21.557l17.586 13.048-6.807 20.423 17.586-12.48z m115.165 0l17.02 12.481-6.809-20.423 17.587-13.048h-21.558l-6.24-20.423-6.808 20.423h-21.558l17.587 13.048-6.808 20.423 17.587-12.48z m-517.39 55.03l17.02 13.048-6.24-20.423 17.019-13.049H62.972l-6.24-20.423-6.808 20.423H28.366l17.586 13.049-6.807 20.423 17.586-13.048z m114.598 0l17.586 13.048-6.808-20.423 17.587-13.049h-21.558l-6.807-20.423-6.24 20.423H143.53l17.02 13.049-6.24 20.423 17.019-13.048z m115.164 0l17.587 13.048-6.808-20.423 17.587-13.049H293.3l-6.808-20.423-6.808 20.423h-21.558l17.587 13.049-6.808 20.423 17.587-13.048z m115.165 0l17.019 13.048-6.24-20.423 17.019-13.049h-21.558l-6.24-20.423-6.808 20.423h-21.558l17.587 13.049-6.808 20.423 17.587-13.048z m114.597 0l17.587 13.048-6.808-20.423 17.586-13.049h-21.557l-6.808-20.423-6.808 20.423h-20.99l17.019 13.049-6.24 20.423 17.019-13.048z m115.164 0l17.587 13.048-6.808-20.423 17.02-13.049h-20.99l-6.809-20.423-6.807 20.423h-21.558l17.586 13.049-6.807 20.423 17.586-13.048z"
											fill="#FFFFFF" p-id="9967"></path>
									</svg>
								</i>
								United States
							</div> -->
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-dialog>
			<el-dialog title="Select Language" top="20vh" class="languages montserRegular" :visible.sync="initial2" @close="onClose">
				<el-select :popper-append-to-body="false" class="w100" v-model="value" placeholder="Select Language" @change="onChange">
					<el-option v-for="(item,key) in options" :key="key" :label="`${item.name}（${item.code}）`" :value="key">
					</el-option>
				</el-select>
				<span slot="footer" class="flex j-center">
					<div class="buzhouann inline-block br-20 ys-0 tit-14 cur_pointer t-center  " style="width: 1.4rem;" @click="onGo"> GO </div>
					<div class="buzhouann inline-block br-20 ys-0 tit-14 cur_pointer t-center ml-15 " style="width: 1.4rem;background: #A3A3A3 !important;" @click="onGuanbi">
						<!-- CANCEL -->
						{{gudingziduan.Exam.Cancel}}
					</div>
				</span>
			</el-dialog>
		</div>
		<el-dialog title="Exam Details" class="languages2 montserRegular" :visible.sync="initial3" center @close="onClose2">
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{gudingziduan.Exam.QuestionType}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{gudingziduan.Exam.QuestionType2}}</span>
			</div>
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{gudingziduan.Exam.FullScore}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{gudingziduan.Exam.FullScore2}}</span>
			</div>
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{gudingziduan.Exam.PassingScore}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{gudingziduan.Exam.PassingScore2}}</span>
			</div>
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{gudingziduan.Exam.Attempts}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{gudingziduan.Exam.Attempts2}}</span>
			</div>
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{gudingziduan.Exam.Interruption}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{gudingziduan.Exam.Interruption2}}</span>
			</div>
			<!-- <div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{l.title}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{l.text}}</span>
			</div>
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{l.title}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{l.text}}</span>
			</div>
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{l.title}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{l.text}}</span>
			</div>
			<div class="tishi pt-10 pb-10" >
				<i style="width: 7px;height: 7px;background: #eb1b21; display: inline-block; border-radius: 50%;"></i>
				<span class="tit-20 ml-7" style="color: #343434;">{{l.title}}</span>：
				<span class="tit-20 montserLight" style="color: #343434;">{{l.text}}</span>
			</div> -->
			<div class="btn flex j-center">
				<div @click="guanbit" class="ann flex a-center j-center ys-0 tit-18 cur_pointer" style="background: linear-gradient(108deg,#ff785c 0%, #e70a16 100%);border-radius: 28px;margin: .7rem auto 0;"><el-image fit="contain" class="tup mr-5" :src="require('@/assets/pc/exam/exam3.png')" alt="" style="" />
					<!-- I got it! -->
					{{gudingziduan.Exam.gotit}}
				</div>
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
	// import Header from '@/zujian/pc/Header.vue'
	let that;
	import { language, continent } from '@/api/language.js';
	import { confirmCountry,allUser } from '@/api/user.js';
	export default {
		data() {
			return {
				value: '',
				languageName: '0',
				options: [],
				datas: {},
				userLanguage: '',
				// options: [{ value: 'en', label: 'English ‎(en)‎' }, { value: 'es_mx', label: 'Español' }],
				// language: ['North America', 'Latin America & The Caribbean', 'Europe', 'Asia Pacific', 'Middle East & Africa'],
				language: [],
				tishi: [
					{ title: 'Question Type', text: 'Multiple-choice and true/false questions.'},
					{ title: 'Full Score', text: '100 points'},
					{ title: 'Passing Score', text: '80 points or above'},
					{ title: 'Attempts', text: 'Unlimited attempts allowed'},
					{ title: 'Interruption', text: 'If you exit midway, you will need to restart the exam'},
				],
				initial: false,
				initial2: false,
				initial3: true,
				gudingziduan:{}
			}
		},
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        // console.log('语言已更新:', newValue);
		        this.gudingziduan=this.$store.state.cunyuanyan
				// console.log(this.gudingziduan,'video')
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		created() {
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan=this.$store.state.cunyuanyan
			console.log(this.gudingziduan)
		},
		mounted() {
			that = this;
			this.CSH()
			this.user()
		},
		methods: {
			dakaiks() {
				this.$router.push({
				  name: "examQuestions", 
				}); // 参数清晰，路径变化时无需修改
				// $dakai('examQuestions')
			},
			CSH() {
				continent().then(shu => {
					if(shu.code=='200') {
						this.language = shu.data
					}
					
				})
			},
			user() {
				allUser().then(shu => {
					if(shu.code=='200') {
						this.userLanguage = shu.data.language
						if(!this.userLanguage)this.initial=true
					}else{
						this.userLanguage=''
					} 
				})
			},
			xuan(id) {
				language({country:id}).then(shu => {
					this.options = shu.data
					
				})
				this.initial2 = true
				this.initial = false
			},
			onClose() {
				this.value = ''
				this.datas = {}
				this.initial2 = false
				this.initial = true
			},
			onChange(e) {
				
				this.datas = {
					"country": this.options[e].country,
					"language": this.options[e].name
				}
				
			},
			onGo() {
				if(this.datas) {
					confirmCountry(this.datas).then(shu => {
						if(shu.code == '200') {
							this.initial = false
							this.initial2 = false
							this.CSH()
							this.user()
						}
					})
				}
			},
			onGuanbi() {
				this.initial2 = false
				this.datas = {}
			},
			onClose2() {
				if(!this.userLanguage){
					this.initial=true
					this.initial3=true
				}
			},
			guanbit(){
				if(this.userLanguage) {
					this.initial3=false
				}else {
					this.initial=true
				}
				
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.exam {
		justify-content: center;
		background: url('../../../assets/pc/exam/exam1.png') no-repeat;background-size:cover;height: 100vh;
		.logot {width: 1.77rem;height: .42rem;top: .52rem;left: .76rem;}
		.readys {
			width: 7.45rem;
			height: 1.91rem;
			background: url('../../../assets/pc/exam/exam2.png') no-repeat;background-size:cover;;
		}
		// 语言
		::v-deep .languages2 {
			display: flex;
			align-items: center;
			justify-content: center;
			.el-dialog__title {font-size: .36rem;  font-family: "montserMedium";}
			.el-dialog {
				width: 888px;
				max-width: 60%;
				margin: auto;
				padding: .5rem .8rem;
			}
			.ann {padding: .12rem .4rem; display: inline-flex; align-items: center;}
			.tup {width: .22rem;height: .22rem;}
		}
		.buzhouann {
			border-radius: 100px;
			padding: .1rem .25rem;
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
		}
		
		::v-deep .languages {
			.el-dialog {
				width: 60%;
				padding: .22rem .17rem;
			}
			.anniu { width: 1.40rem; height: .47rem; border-radius: 24px;}
			// .el-dialog__title {
			// 	font-size: var(--font22);
			// }
		
			.el-dialog__body {
				padding: .1rem .2rem;
			}
		
			.is-active {
				font-family: "montserRegular";
				font-weight: 700;
				color: #E60012;
			}
		
			.el-tabs__item {
				font-family: "montserLight";
				font-size: .15rem;
			}
		
			.neirong {
				background: #f9f9f9;
				border-radius: 10px;
				padding: .1rem .27rem;
		
				.guojia {
					padding: .08rem 0;
					i {
						line-height: .1rem;
						margin-right: .1rem;
					}
				}
			}
		
			.el-dialog__close {
				color: #2E2E2E;
				font-size: .2rem;
			}
		
			.el-tabs__active-bar {
				background-color: #E60012;
			}
		
			.el-tabs__item:hover {
				color: #E60012;
			}
		}
		::v-deep.el-dialog {
			border-radius: .1rem;
		}
		::v-deep.el-dialog__footer {
			// padding-bottom: .5rem;
			padding: .3rem .2rem;
		}
		::v-deep .el-select{
			padding: .1rem 0;
			border: 1px solid #c7c7c7;
			border-radius: 10px;
			.el-input .el-select__caret {
				line-height: 16px;
			}
			.el-input__inner {border: none;}
		}
		
		::v-deep .el-popper {
			.el-select-dropdown__item.selected {color: #E60012 !important;}
		}
		.annius {padding: .12rem .5rem;background: linear-gradient(112deg,#ff785c 0%, #e70a16 100%);border-radius: 31px;}
	}



// ==========================================================================================================================================================================
// 响应式


@media screen and (max-width: 767px) {
	.exam ::v-deep .languages2 .el-dialog {max-width: 90%; padding: .3rem 0;}
	.exam .readys {max-width: 90%; background-size: contain;}
}
	
</style>